export default {
  role1: 'Show Tech',
  role2: 'Production',
  role3: 'Show Caller',
  role4: 'Client',
};
